<template>
    <sharepoint-files
        :editing="$store.getters.isAdmin && $store.getters.isEditing"
        :folder-path="folderPath"
        :sort="sort"
        :direction="direction"
        :limit="limit"
        :display="display"></sharepoint-files>
</template>
<script>
import { computed, inject } from "vue";
import sharepointFiles from "@/components/webComponents/widget/sharepointFiles/sharepointFiles.vue";

export default {
    components: {
        sharepointFiles
    },
    props: {
        folder: {
            type: [String, Object],
            default: null
        },
        sort: {
            type: String,
            default: null
        },
        direction: {
            type: [String, Number, Boolean],
            default: null
        },
        limit: {
            type: [String, Number],
            default: null
        },
        display: {
            type: String,
            default: "Promo"
        }
    },
    setup(props) {
        const $json = inject("$json");

        const folderPath = computed(() => {
            if (!$json.packed(props.folder)) {
                if (!props.folder) {
                    return "";
                }
                if (typeof props.folder === "string") {
                    return props.folder;
                }
                return props.folder.path || props.folder.id || "";
            }

            const unpacked = JSON.parse($json.unpack(props.folder));
            return unpacked.path || unpacked.id || "";
        });

        return {
            folderPath
        };
    }
};
</script>
